// Where the household stands, in four boxes.
//
// This is the advisor lead's own second-meeting mental model, put on the page:
// He sketched it as a SWOT one-pager years ago and the page used to keep the
// shape while paraphrasing the labels, on the theory that "Levers you can still
// pull" was warmer than "Opportunities". It reads as evasion instead: advisors
// know the frame, clients recognise it, and naming the boxes plainly is shorter
// than talking around them. Ordered positives first, then negatives, for the
// same reason the strengths box leads: the page has to open with credit for
// the rest not to read as an audit.
//
// It is in the report and out of the default meeting: the advisor lead's
// September comments do not make it a mandatory slide, and an advisor who
// wants it in a given meeting has the checkbox.
//
// Replaces the ranked "Three things we noticed" list. The facts are the same,
// but organized this way the page opens with credit where credit is due, which
// is what stops the rest from reading as an audit. Every entry is decided in
// getSituationSummary and arrives fully written; this component chooses no
// wording and computes no number.

const QUADRANTS = [
  { key: 'working', title: 'Strengths', tone: 'good' },
  { key: 'levers', title: 'Opportunities', tone: 'lever' },
  { key: 'attention', title: 'Weaknesses', tone: 'warn' },
  { key: 'risks', title: 'Threats', tone: 'risk' },
];

export default function SituationSummary({ situation }) {
  if (!situation) return null;
  const shown = QUADRANTS.filter(q => situation[q.key]?.length);
  if (!shown.length) return null;

  return (
    <section className="asmt-card asmt-findings" id="findings">
      <div className="asmt-card-head">
        <h2>Where you stand</h2>
        <span className="asmt-card-note">read from your answers and your statements</span>
      </div>
      <div className="asmt-sw-grid">
        {shown.map(q => (
          <div className={`asmt-sw-quad is-${q.tone}`} key={q.key}>
            <h3 className="asmt-sw-title">{q.title}</h3>
            <ul className="asmt-sw-list">
              {situation[q.key].map(item => (
                <li className="asmt-sw-item" key={item.key}>
                  <div className="asmt-sw-headline">{item.headline}</div>
                  {item.detail && <p className="asmt-sw-detail">{item.detail}</p>}
                  {(item.section || item.sectionLabel) && (
                    <a className="asmt-finding-link no-print" href={`#${item.section}`}>
                      {item.sectionLabel || 'See the detail below'}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
}
